import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Puff } from 'react-loader-spinner'
import { BiTrash, BiBookOpen } from 'react-icons/bi'
import { IoIosAdd } from 'react-icons/io'
import { getCulture, deleteCulture } from '../../actions/culture'
import Button from '../../components/Button'
import Table from '../../components/Table'
import Confirmation from '../../components/Confirmation/Confirmation'
import CultureModal from './Modal'
import styles from './styles.module.scss'

export default function Culture() {
  const dispatch = useDispatch()
  const { cultureList, loading } = useSelector(state => state.culture)
  const list = cultureList?.culture || []

  const [selectedItem, setSelectedItem] = useState(null)
  const [confirmation, setConfirmation] = useState(null)
  const [isDeleting, setIsDeleting] = useState(false)

  useEffect(() => {
    dispatch(getCulture())
  }, [dispatch])

  const openModal = (item) => () => {
    setSelectedItem(item || {})
  }

  const closeModal = () => setSelectedItem(null)

  const handleDelete = (item) => (e) => {
    e.stopPropagation()
    setConfirmation({ id: item.id, name: item.name })
  }

  const acceptConfirmation = async () => {
    if (!confirmation || isDeleting) return
    setIsDeleting(true)
    try {
      await dispatch(deleteCulture(confirmation.id))
    } finally {
      setConfirmation(null)
      setIsDeleting(false)
    }
  }

  const rejectConfirmation = () => setConfirmation(null)

  const renderLoading = () => (
    <div className={styles.loadingState}>
      <Puff height={50} width={50} color="#3689FF" ariaLabel="Загрузка..." />
      <span>Загрузка записей...</span>
    </div>
  )

  const renderEmptyState = () => (
    <div className={styles.emptyState}>
      <BiBookOpen size={64} className={styles.emptyIcon} />
      <p>Нет добавленных записей</p>
      <Button onClick={openModal()}>Добавить первую запись</Button>
    </div>
  )

  const renderTable = () => (
    <div className={styles.tableContainer}>
      <Table className={styles.table} maxHeight="calc(100vh - 300px)">
        <thead>
          <tr>
            <th>Название</th>
            <th style={{ width: '96px' }}>Удалить</th>
          </tr>
        </thead>
        <tbody>
          {list.map((item) => (
            <tr key={item.id} onClick={openModal(item)}>
              <td className={styles.nameCell}>
                <span className={styles.itemName}>{item.name}</span>
              </td>
              <td>
                <button
                  type="button"
                  className={styles.deleteBtn}
                  onClick={handleDelete(item)}
                  title={`Удалить запись ${item.name}`}
                  aria-label={`Удалить запись ${item.name}`}
                >
                  <BiTrash size={20} />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <div className={styles.actions}>
        <Button style={{ padding: '.5rem 1.5rem' }} onClick={openModal()}>
          <IoIosAdd size={30} />
          Добавить
        </Button>
        <span className={styles.counter}>
          Всего записей: {list.length}
        </span>
      </div>
    </div>
  )

  return (
    <div className={styles.wrapper}>
      <header className={styles.header}>
        <h1>Культура</h1>
      </header>

      <main className={styles.content}>
        {loading && renderLoading()}
        {!loading && list.length === 0 && renderEmptyState()}
        {!loading && list.length > 0 && renderTable()}
      </main>

      {selectedItem !== null && (
        <CultureModal
          open
          onClose={closeModal}
          data={selectedItem}
          addMode={!selectedItem.id}
          list={list}
        />
      )}

      {confirmation && (
        <Confirmation
          title={`Вы уверены, что хотите удалить запись справочника «${confirmation.name}»?`}
          acceptConfirmation={acceptConfirmation}
          rejectConfirmation={rejectConfirmation}
        />
      )}
    </div>
  )
}
